import * as angular from "angular";
import * as _ from "lodash";
import {getMetersPerLargeDistanceUnit, METERS_PER_KILOMETER} from "../utils/distance-unit.util";

angular
  .module('bringoz.admin.commons')
  .filter('bringozSpeed', bringozSpeed);

function bringozSpeed(splitService, $filter) {

  const speedConfig = splitService.getSiteDistanceLargeUnit(true),
    factor = getMetersPerLargeDistanceUnit(speedConfig === 'MI') / METERS_PER_KILOMETER;

  return function bringozSpeedFilter(speedKmh, defaultValue) {

    if (!_.isUndefined(speedKmh)) {
      const unitKey = speedConfig === 'MI' ? 'MPH' : 'KMH';
      return (speedKmh / factor).toFixed(0).toString() + ' ' + $filter('translate')(unitKey);
    } else {
      return defaultValue || '---';
    }
  }
}
